export class saveLoad {
    constructor(state, uiManager = null) {
        this.state = state;
        this.uiManager = uiManager;
        this.setupEventListeners();
    }

    setUIManager(uiManager) {
        this.uiManager = uiManager;
    }

    setupEventListeners() {
        const resetButton = document.getElementById("reset-game-button");
        if (resetButton) {
            resetButton.addEventListener("click", () => {
                console.log("Hard reset triggered.");
                this.hardReset();
            });
        }

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                this.saveState();
            }
        });

        window.addEventListener("beforeunload", (event) => {
            this.saveState();
        });
    }

    saveState() {
        this.state.lastSaved = Date.now();

        this.state.savedWorlds = this.state.worldHandler.saveToData();

        this.state.savedSpells = this.state.spellHandler.saveToData();
        
        this.state.savedHuntingData = this.state.huntingHandler.saveToData();

        this.state.savedSouls = this.state.soulHandler.saveToData();

        localStorage.setItem('gameState', JSON.stringify(this.state));
        console.log("Game Saved");
    }

    loadState() {
        const savedGameState = localStorage.getItem('gameState');
        
        if (savedGameState) {
            const parsed = JSON.parse(savedGameState);

            // This naturally passes parsed.savedMonsters into your gameState's loadFromJSON method!
            this.state.loadFromJSON(parsed);

            // Update DOM attributes to match loaded UI state
            if (this.uiManager) {
                this.uiManager.applyUiState();
            }

            // offline progress
            const now = Date.now();
            const lastSaved = parsed.lastSaved || now;
            const offlineMs = now - lastSaved;

            console.log(`Game loaded ${(offlineMs / 1000).toFixed(1)} seconds passed`);
            
            // offline progress simulation
            // this.state.simulateOfflineTime(offlineMs);

        } else {
            console.log("no save file found");
        }
    }

    hardReset() {
        localStorage.removeItem('gameState');
        this.state.reset();
        this.saveState();  
        window.location.reload(); 
        console.log("game reset");
    }
}